import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { ProductionManagementReducer } from "../reducers/ProductionManagementReducer";

const ProductionManagementContext = createContext({
	state: ProductionManagementReducer.getInitialState(),
	actions: ProductionManagementReducer.actions,
});

export const useProductionManagementContext = () =>
	useContext(ProductionManagementContext);

export const ProductionManagementProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const [state, actions] = useComplexState({
		initialState: ProductionManagementReducer.getInitialState(),
		reducers: ProductionManagementReducer.caseReducers,
	});

	return (
		<ProductionManagementContext.Provider value={{ state, actions }}>
			{children}
		</ProductionManagementContext.Provider>
	);
};
